<script setup>
const fullWidthMode = inject("fullWidthMode", false);
const halfCol = computed(() => (fullWidthMode ? undefined : 6));
import PersonalitySub20Info from './ContentsPersonality20_info.vue';
import PersonalitySub20Rate from './ContentsPersonality20_rate.vue';

const emit = defineEmits(['goToOverView', 'postRate']);
const props = defineProps({
  ratingResult: Number,
  ratingStatus: Boolean,
  showFullLayout: {
    type: Boolean,
    default: true,
  },
});

const goToOverView = () => {
  emit('goToOverView');
};

const postRate = (score) => {
  emit('postRate', score);
};
</script>

<template>
  <VRow class="full-height">
    <!-- 3상면 좌우 분할 이지웃 -->
    <template v-if="showFullLayout">
      <VCol cols="12" :md="halfCol" class="no-pad-col mobile-first">
        <PersonalitySub20Info />
      </VCol>
      <VCol cols="12" :md="halfCol" class="no-pad-col mobile-second">
        <PersonalitySub20Rate
          :ratingResult="ratingResult"
          :ratingStatus="ratingStatus"
          @goToOverView="goToOverView"
          @postRate="postRate"
        />
      </VCol>
    </template>

    <!-- 3미만면 rate 컴포넌트 시작 -->
    <template v-else>
      <VCol cols="12" class="no-pad-col d-flex justify-center">
        <VCol cols="12" :md="halfCol" class="no-pad-col">
          <PersonalitySub20Rate
            :ratingResult="ratingResult"
            :ratingStatus="ratingStatus"
            @goToOverView="goToOverView"
            @postRate="postRate"
          />
        </VCol>
      </VCol>
    </template>
  </VRow>
</template>
<style scoped>
/* 각각 분리 컴포넌트로 관리됩니다 */
</style>
